

import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getBuyerForecastSearchTable = createApi(`BuyerForecastSearchTableSlice`,"POST");

const BuyerForecastSearchTableSlice = createSlice({
  name: 'BuyerForecastSearchTableSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBuyerForecastSearchTable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBuyerForecastSearchTable.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBuyerForecastSearchTable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default BuyerForecastSearchTableSlice.reducer;